import React from 'react';
import { TelegramBot } from '../../types/admin';
import './AdminStyles.css';

interface TelegramBotsListProps {
  bots: TelegramBot[];
  loading: boolean;
  testingId?: number | null;
  onEdit: (bot: TelegramBot) => void;
  onDelete: (id: number) => void;
  onToggle: (id: number) => void;
  onTest: (id: number) => void;
}

// Lista dedicada dos bots do Telegram (multi-bot).
export const TelegramBotsList: React.FC<TelegramBotsListProps> = ({
  bots,
  loading,
  testingId,
  onEdit,
  onDelete,
  onToggle,
  onTest,
}) => {
  const getCreatedAt = (bot: TelegramBot) => {
    const value = bot.createdAt ?? bot.created_at;
    return value ? new Date(value).toLocaleDateString('pt-BR') : '—';
  };

  if (loading) {
    return <div className="accounts-loading">Carregando bots...</div>;
  }

  if (bots.length === 0) {
    return (
      <div className="accounts-empty">
        <p>Nenhum bot do Telegram configurado</p>
      </div>
    );
  }

  return (
    <div className="accounts-table-container">
      <table className="accounts-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Bot</th>
            <th>Bot ID</th>
            <th>V8</th>
            <th>Link</th>
            <th>Status</th>
            <th>Criado</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {bots.map(bot => (
            <tr key={bot.id} className={!bot.is_active ? 'account-inactive' : ''}>
              <td>{bot.id}</td>
              <td className="account-title">@{bot.bot_username}</td>
              <td className="account-identifier">{bot.bot_id}</td>
              <td className="account-identifier">{bot.V8Auth?.login || (bot.v8_id ? `#${bot.v8_id}` : '—')}</td>
              <td>
                <a href={`https://t.me/${bot.bot_username}`} target="_blank" rel="noopener noreferrer">
                  t.me/{bot.bot_username}
                </a>
              </td>
              <td>
                <button
                  className={`status-badge ${bot.is_active ? 'active' : 'inactive'}`}
                  onClick={() => onToggle(bot.id)}
                >
                  {bot.is_active ? 'Ativo' : 'Inativo'}
                </button>
              </td>
              <td className="account-date">{getCreatedAt(bot)}</td>
              <td className="account-actions">
                <button
                  className="btn-edit"
                  onClick={() => onTest(bot.id)}
                  disabled={testingId === bot.id}
                  title="Testar (envia mensagem para um chat_id que já iniciou o bot)"
                >
                  {testingId === bot.id ? '⏳' : '🧪'}
                </button>
                <button className="btn-edit" onClick={() => onEdit(bot)} title="Editar">
                  ✏️
                </button>
                <button
                  className="btn-delete"
                  onClick={() => {
                    if (window.confirm(`Deletar bot @${bot.bot_username}?`)) {
                      onDelete(bot.id);
                    }
                  }}
                  title="Deletar"
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
